import * as Ariakit from '@ariakit/react'

import { Separator } from '../../layout'

export const MenuSeparator = () => (
  <Ariakit.MenuSeparator
    render={(props) => <Separator orientation='horizontal' my={2} {...props} />}
  />
)
